import { useSelector } from 'react-redux';
import { getLimitingFeaturesKeys } from 'domains/Auth/authSlice/authSelectors';

export function useHasLimitingFeature(limitingFeatureKey: string) {
  const limitingFeaturesKeys = useSelector(getLimitingFeaturesKeys);

  return limitingFeaturesKeys.includes(limitingFeatureKey);
}
